// How we reach a user (the medium).
export enum CommunicationChannel {
  EMAIL = 'email',
  SMS = 'sms',
  COACH_MESSAGE = 'coach_message'
}

// What a message is about. Every category can be opted out of.
export enum CommunicationCategory {
  SPRINT_INVITATION = 'sprint_invitation',
  SESSION_REMINDER = 'session_reminder',
  COACH_MESSAGES = 'coach_messages',
  MARKETING = 'marketing',
  // Long-term follow-up engine categories (each independently opt-out-able).
  POST_SESSION_COACH_EMAIL = 'post_session_coach_email',
  LONG_TERM_NUDGE = 'long_term_nudge'
}
